import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Import your screens
import Home from './screens/Home';
import Review from './screens/Review';
import Design from './screens/Design';

function App() {
  return (
    <Router>
      <div>
        {/* Define the different routes */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/review/:design_id" element={<Review />} />
          <Route path="/design/:design_id" element={<Design />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;